module["exports"] = [
  "巷",
  "街",
  "路",
  "桥",
  "侬",
  "旁",
  "中心",
  "栋"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/zh_CN/address/street_suffix.js
// module id = 2089
// module chunks = 1